import CoverUploader from 'component_ui/cover-uploader';
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

$(() => {
    const csrfParam = $('meta[name=csrf-param]').attr('content');
    const csrfToken = $('meta[name=csrf-token]').attr('content');

    CoverUploader.attachTo('[data-page-wrapper]', {
        csrfParam,
        csrfToken,
    });

    $(document).trigger('uiNeedsContestsOpenForInvitation');
    $(document).trigger('uiNeedsContestsUserProfile');
});



// WEBPACK FOOTER //
// ./src/js/component_ui/designer-profile-header.js